export const DoNotSellMyPersonalDataURL =
'https://www.colgatepalmolive.com/en-us/legal-privacy-policy/japan';
